import HelperTip from "components/HOCS/HelperTip";
import React from "react";
import { useSelector } from "react-redux";
import MyMedia from "./MyMedia/MyMedia";
import RemoteMedia from "./RemoteMedia/RemoteMedia";
import HlpSideVideos from "components/HelpSlides/Spaces/HlpSideVideos";
import { FM_SIDEVIDEOS } from "helpers/freshman";
import {
  selectMeFocus,
  selectSpaceLayoutValue,
  SPACE_LAYOUT,
  selectRunningVideos,
  selectSpaceBoxActive,
  tryOpenGrid,
  tryEnlargeFirst,
} from "slices/spaceMediaSlice";
// import MoreOptionsTippy from "components/HOCS/MoreOptionsTippy";
// import { getVideoExpandOptions } from "../MyControlBar/SpaceBoxActiveControls/SpaceBoxActiveControls";

export const MEDIA_ARRAY = "media-array";
export const REMOTE_MEDIA_ARRAY = "remote-media-array";

const MediaArray = () => {
  window.efs_debug && window.log("MEDIA ARRAY");
  const myVideoActive = false;
  const focusMode = useSelector(selectMeFocus);
  const spaceBoxActive = useSelector(selectSpaceBoxActive);
  const spaceLayoutValue = useSelector(selectSpaceLayoutValue);
  const runningVideos = useSelector(selectRunningVideos);
  const meFocus = useSelector(selectMeFocus);

  // let videoOptions = getVideoExpandOptions(spaceLayoutValue, runningVideos);

  return (
    <HelperTip
      component={<HlpSideVideos />}
      placement="left"
      code={FM_SIDEVIDEOS}
      style={{ height: "340px" }}
      arrowWhite
      lazy
    >
      <div
        id={MEDIA_ARRAY}
        className={`media-array ${spaceBoxActive ? "space-shown" : ""} ${
          meFocus ? "focusing" : ""
        } ${spaceLayoutValue !== SPACE_LAYOUT ? "grid-active" : ""}`}
      >
        {spaceBoxActive &&
          spaceLayoutValue === SPACE_LAYOUT &&
          runningVideos > 0 && (
            // <MoreOptionsTippy
            //   options={videoOptions}
            //   placement="left"
            //   offset={[0, 0]}
            //   customStyle={{ width: "193px" }}
            //   disabled={runningVideos < 1}
            // >
            <div
              className="expand-hitbox"
              onClick={() => {
                if (!tryOpenGrid()) {
                  tryEnlargeFirst();
                }
              }}
            >
              <div className="expand-button">
                <svg
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.846995 7.45601L7.59577 0.706982C7.98628 0.316357 8.61653 0.31953 9.00337 0.713573C9.39021 1.10786 9.38728 1.74385 8.99665 2.13447L2.74922 8.38203L8.92219 14.5551C9.28681 14.9196 9.2895 15.5134 8.92842 15.8815C8.56721 16.2495 7.97895 16.2521 7.61433 15.8876L0.660106 8.93354C0.295604 8.5688 0.292796 7.97505 0.65388 7.60688C0.71284 7.54683 0.777904 7.49653 0.846995 7.45601Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
            // </MoreOptionsTippy>
          )}
        <MyMedia />
        <div
          className={`remote-media-wrapper ${
            spaceLayoutValue === SPACE_LAYOUT ? "position-relative" : ""
          }`}
        >
          <div
            id={REMOTE_MEDIA_ARRAY}
            className={`remote-media ${myVideoActive ? "my-video-active" : ""}`}
          >
            {!focusMode && <RemoteMedia />}
          </div>
        </div>
      </div>
    </HelperTip>
  );
};
export default MediaArray;
